// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ah-0";
export var orangeButton = "_ah-1";